import { put, call, select, takeLatest } from "redux-saga/effects";

import { getEmailFormData } from "../reducers/emailForm";
import * as actions from "../actions/emailForm";
import * as types from "../constants/ActionTypes";
import Api from "../Api";

function* submit() {
  const formData = yield select(getEmailFormData);
  const { response, error } = yield call(Api.changeEmail, formData);

  if (error) {
    yield put(actions.submitFailure(error));
  } else {
    yield put(actions.submitSuccess(response));
  }
}

function* watch() {
  yield takeLatest(types.EMAIL_FORM_WILL_SUBMIT, submit);
}

export default watch;

export { submit };
